import { makeStyles } from '@material-ui/core/styles'

export const singleLateSubmissionStyles = makeStyles((theme) => ({
  lateSubmissionDataWrapper: {
    width: '100%',
    padding: theme.spacing(3, 3, 5),
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  }
}))
